<ng-container *transloco="let t;">

  <form (submit)="onSubmit()" novalidate *ngIf="owner !== null">

    <div class="p-grid">
      <div class="p-col-6">
        <h2>{{ t('common.labels.contents') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button [withRight]="editRight" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
        <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
        <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div>
      <app-pill-nav [entries]="navEntries" (select)="onSelectLanguage($event)"></app-pill-nav>
    </div>

    <div class="p-grid p-mt-4">
      <div [ngClass]="{'p-col-12': isTextBlockMode(), 'p-col-9': !isTextBlockMode()}">
        <h3>{{ t('common.labels.content_for') }} <strong *ngIf="selectedLanguage !== null">{{selectedLanguage.name}}</strong></h3>
        <ng-container *ngIf="inEdit === true">
          <app-form-control *ngIf="!isTextBlockMode() && owner.type === 'mail'" [cid]="'title'" [control]="form.get('title')" [type]="'input'" [label]="t('common.labels.title')"></app-form-control>
          <app-form-control *ngIf="owner.type === 'sms'" [cid]="'content'" [control]="form.get('content')" [type]="'textarea'" [label]="t('common.labels.content')"></app-form-control>
          <editor *ngIf="owner.type !== 'sms'" style="width: 100%; height: 500px;" [formControl]="form.get('content')" [init]="getEditorInit()"></editor>
        </ng-container>
        <ng-container *ngIf="inEdit !== true">
          <h4 *ngIf="!isTextBlockMode() && owner.type === 'mail'">{{ contents[selectedLanguage.key]?.title }}</h4>
          <div *ngIf="owner.type !== 'sms'" [innerHtml]="contents[selectedLanguage.key]?.content"></div>
          <div *ngIf="owner.type === 'sms'" [innerHtml]="contents[selectedLanguage.key]?.content | nl2br "></div>
        </ng-container>
      </div>
      <div class="p-col-3" *ngIf="!isTextBlockMode()">
        <app-placeholders [edit]="inEdit" [mode]="mode" [language]="selectedLanguage.key" [context]="owner.context" [template]="template"></app-placeholders>
      </div>
    </div>

  </form>

  <p-dialog [header]="t('common.labels.preview')" [(visible)]="previewVisible" [style]="{width: '90vw'}" [draggable]="false">
    <app-loader [loading]="previewLoading === true"></app-loader>
    <div *ngIf="previewLoading !== true" [innerHtml]="previewContent"></div>
  </p-dialog>

  <p-dialog [header]="t('common.labels.send_preview')" [(visible)]="sendVisible" [style]="{width: '50vw'}" [draggable]="false">
      <div>
        <app-form-control [cid]="'recipient'" [control]="sendForm.get('recipient')" [type]="'input'" [label]="t('common.labels.recipient')"></app-form-control>
      </div>
      <ng-template pTemplate="footer">
        <button pButton type="button" (click)="onSendPreview()" aria-label="{{ t('common.labels.send') }}" [label]="t('common.labels.send')" [loading]="sendSending" autofocus></button>
      </ng-template>
  </p-dialog>

</ng-container>
